import { render, staticRenderFns } from "./stucomment.vue?vue&type=template&id=375571e2&scoped=true"
import script from "./stucomment.vue?vue&type=script&lang=js"
export * from "./stucomment.vue?vue&type=script&lang=js"
import style0 from "./stucomment.vue?vue&type=style&index=0&id=375571e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375571e2",
  null
  
)

export default component.exports